module.exports = __webpack_public_path__ + "img/grinning-face.affcc7d8.png";